(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7266],{

/***/ 12276:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...segments]]",
      function () {
        return __webpack_require__(76092);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Th": function() { return /* binding */ LargeScreenCssSwitchLongerLangs; },
/* harmony export */   "iK": function() { return /* binding */ SmallScreenCssSwitchLongerLangs; },
/* harmony export */   "kU": function() { return /* binding */ LargeScreenCssSwitch; },
/* harmony export */   "vH": function() { return /* binding */ SmallScreenCssSwitch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43119);
/* harmony import */ var _styles_mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46735);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61258);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media ",
        " {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (max-width: 1068px) {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media ",
        " {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	@media (min-width: 1068px) {\n		display: none;\n	}\n	display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var LargeScreenCssSwitch = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6bb99f1-0"
}).withConfig({
    componentId: "sc-49a4a71b-0"
})(_templateObject(), _styles_mixins__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.belowLarge */ .w5.belowLarge);
var LargeScreenCssSwitchLongerLangs = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6bb99f1-1"
}).withConfig({
    componentId: "sc-49a4a71b-1"
})(_templateObject1());
var SmallScreenCssSwitch = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6bb99f1-2"
}).withConfig({
    componentId: "sc-49a4a71b-2"
})(_templateObject2(), _styles_mixins__WEBPACK_IMPORTED_MODULE_1__/* .mediaQueries.large */ .w5.large);
var SmallScreenCssSwitchLongerLangs = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f6bb99f1-3"
}).withConfig({
    componentId: "sc-49a4a71b-3"
})(_templateObject3());


/***/ }),

/***/ 10299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78723);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7707);








var Hopin = function Hopin(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "fill",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, (0,_services_utils__WEBPACK_IMPORTED_MODULE_3__/* .omitNonReactProps */ .ly)(otherProps)), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.1539 5.75345C14.1303 6.68599 13.4683 8.01485 12.3571 8.01485C11.6715 8.01485 11.1041 7.45532 11.1041 6.77925V6.75593C11.0805 5.6602 10.584 4.70436 9.8038 4.02827C9.21276 3.53868 8.47985 3.2123 7.67603 3.11904C8.36164 2.41964 9.33096 2 10.3949 2C11.7424 2 12.9718 2.76934 13.6811 3.88839C14.0121 4.4479 14.1776 5.12399 14.1539 5.75345Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9.75662 5.84697C10.3477 6.593 10.7023 8.01511 9.85119 8.71452C9.30743 9.15747 8.52724 9.08753 8.07805 8.57464C7.34515 7.75867 6.32855 7.33903 5.31194 7.31572C4.53175 7.2924 3.75157 7.52553 3.0896 7.96849C3.16052 7.01264 3.60972 6.05679 4.43718 5.3807C5.50107 4.51811 6.99052 4.26166 8.26718 4.77455C8.85824 4.98437 9.37836 5.35739 9.75662 5.84697Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M6.44658 8.69051C7.36861 8.87701 8.59799 9.76292 8.40886 10.8353C8.29064 11.5114 7.62867 11.9544 6.94306 11.8378H6.91941C5.83189 11.6746 4.768 12.001 3.98782 12.6305C3.39677 13.0967 2.92393 13.7728 2.71115 14.5422C2.14374 13.7495 1.88368 12.747 2.04918 11.6979C2.30924 10.3691 3.27856 9.25003 4.60251 8.80707C5.19355 8.62056 5.85552 8.57394 6.44658 8.69051Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.76115 12.9803C6.58861 12.5373 8.1017 12.4441 8.64547 13.3766C9.0001 13.9594 8.78731 14.7287 8.19627 15.0784C7.25059 15.638 6.65955 16.5472 6.44676 17.5497C6.30492 18.2957 6.37584 19.0883 6.73047 19.8111C5.78479 19.5779 4.91004 18.9718 4.38991 18.0625C3.70429 16.8736 3.72794 15.4049 4.4372 14.2391C4.76818 13.7029 5.21738 13.26 5.76115 12.9803Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M8.03064 16.687C8.38527 15.8244 9.4728 14.7986 10.4894 15.1716C11.1514 15.4047 11.4824 16.1274 11.2459 16.7569C10.8913 17.7828 11.0332 18.8551 11.5296 19.741C11.9079 20.4171 12.4753 20.9533 13.2083 21.303C12.3098 21.7227 11.2696 21.8159 10.2766 21.4429C8.97631 20.9766 8.03064 19.8343 7.81786 18.4821C7.74693 17.876 7.81786 17.2465 8.03064 16.687Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.1918 18.086C11.8844 17.2001 12.0499 15.7313 13.0902 15.3583C13.7521 15.1252 14.4613 15.4516 14.6978 16.1043C15.0997 17.1068 15.9035 17.8528 16.8728 18.2259C17.5822 18.5056 18.4096 18.5522 19.1898 18.3657C18.7879 19.2516 18.0314 19.9744 17.0384 20.3473C15.738 20.8136 14.2486 20.5338 13.232 19.6247C12.7592 19.1817 12.3809 18.6688 12.1918 18.086Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M16.3055 16.5242C15.5017 16.0347 14.6505 14.7991 15.218 13.8666C15.5726 13.2837 16.3292 13.0739 16.9438 13.4002C17.9132 13.9131 19.0007 13.9831 19.9937 13.6567C20.7265 13.4002 21.3886 12.934 21.8614 12.2812C22.1214 13.2137 22.0269 14.2396 21.4831 15.1488C20.7975 16.3377 19.4735 17.0605 18.1023 17.0139C17.4403 17.0139 16.802 16.8506 16.3055 16.5242Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.4333 12.724C17.4876 12.8639 16.0454 12.4443 15.8563 11.3718C15.7144 10.7191 16.1873 10.0663 16.8729 9.94973H16.8966C17.9841 9.7399 18.8588 9.08713 19.3789 8.22454C19.7808 7.57176 19.97 6.80242 19.899 6.00977C20.7029 6.54597 21.3175 7.40857 21.4831 8.43435C21.7195 9.76322 21.1757 11.162 20.1118 12.0013C19.6154 12.3743 19.0243 12.6541 18.4333 12.724Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M17.582 8.48101C16.9436 9.18042 15.5725 9.78657 14.7213 9.08716C14.1776 8.64421 14.1067 7.87486 14.5559 7.33866C15.2415 6.49938 15.5016 5.42697 15.336 4.42449C15.2178 3.67846 14.8632 2.95574 14.2958 2.37291C15.2651 2.27966 16.2817 2.55942 17.1092 3.2355C18.1731 4.09809 18.6696 5.52021 18.3858 6.84907C18.2676 7.45522 17.9839 8.03806 17.582 8.48101Z"
            })
        ]
    }));
};
Hopin.propTypes = {
    size: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number)
    ]),
    fill: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
Hopin.defaultProps = {
    size: 24,
    fill: _styles_theme__WEBPACK_IMPORTED_MODULE_4__/* ["default"].colors.icon */ .Z.colors.icon
};
/* harmony default export */ __webpack_exports__["Z"] = (Hopin);


/***/ }),

/***/ 10580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7707);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78723);








var OnAirBasic = function OnAirBasic(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "fill",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        focusable: "false",
        "aria-hidden": "true",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0,_services_utils__WEBPACK_IMPORTED_MODULE_4__/* .omitNonReactProps */ .ly)(otherProps)), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.36099 2.95433C9.30393 2.978 9.24855 3.004 9.1949 3.03218C7.65074 3.72094 6.35262 4.98316 5.65442 6.67096L4.31124 9.91791L6.47561 9.91791L7.50253 7.43548C8.01464 6.19753 8.97991 5.28426 10.1267 4.80833C10.1276 4.80795 10.1282 4.80665 10.1291 4.80627L10.1272 4.80174C10.2018 4.7708 10.2773 4.74165 10.3525 4.71469C10.926 4.5091 11.5153 4.41833 12.0939 4.43145C13.9569 4.47372 15.7092 5.59322 16.469 7.4252L18.9231 13.3421C19.0463 13.597 19.157 13.8634 19.254 14.1401L20.6879 17.5973C20.0293 17.8705 19.3449 17.9878 18.6758 17.9664C16.8298 17.9071 15.0997 16.7909 14.3461 14.9739L14.1205 14.4298L9.86092 14.4297L9.63236 14.9822C8.88041 16.7999 7.1514 17.9177 5.30544 17.9787C4.63699 18.0007 3.95319 17.8843 3.2949 17.6123L3.29297 17.6115L4.92725 13.6608C4.33569 13.1745 3.86566 12.4853 3.58428 11.6752L1.44486 16.847C1.2421 17.3371 1.24235 17.8877 1.44556 18.3777C1.64877 18.8676 2.0383 19.2568 2.52845 19.4596C6.02576 20.9063 10.0337 19.244 11.4805 15.7467L11.9903 14.5143L12.4987 15.7401C13.9487 19.2361 17.9582 20.8947 21.4541 19.4447C21.9441 19.2415 22.3333 18.852 22.536 18.3618C22.7388 17.8717 22.7385 17.3211 22.5353 16.8311L18.3164 6.65898C16.8665 3.163 12.857 1.50436 9.36099 2.95433ZM11.7273 9.91791H12.2491L11.9879 9.28803L11.7273 9.91791Z",
                fill: fill
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.9584 15.618C20.5813 16.1287 19.9842 16.4301 19.3494 16.43L6.99474 16.4297C3.49392 16.4296 1.29297 13.126 1.29297 9.91797C1.29297 9.38754 1.50368 8.87883 1.87876 8.50376C2.25383 8.12868 2.76254 7.91797 3.29297 7.91797L14.005 7.91797C17.468 7.91797 20.2327 10.5035 21.2608 13.8413C21.4477 14.448 21.3355 15.1073 20.9584 15.618ZM19.3494 14.43C19.1212 13.6891 18.7966 13.0164 18.3968 12.43C17.3322 10.8682 15.7345 9.91797 14.005 9.91797H3.29297C3.29297 10.6362 3.43067 11.3152 3.67566 11.918C4.28059 13.4063 5.53964 14.4296 6.99481 14.4297L19.3494 14.43Z",
                fill: fill
            })
        ]
    }));
};
OnAirBasic.propTypes = {
    size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)
    ]),
    fill: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
OnAirBasic.defaultProps = {
    size: 24,
    fill: _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].colors.icon */ .Z.colors.icon
};
/* harmony default export */ __webpack_exports__["Z"] = (OnAirBasic);


/***/ }),

/***/ 58966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _components_MaterialIcons_Dns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77337);
// The RTMP server destination icon is just the material dns icon

/* harmony default export */ __webpack_exports__["Z"] = (_components_MaterialIcons_Dns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ }),

/***/ 76381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7707);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78723);








var Twitch = function Twitch(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "fill",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, (0,_services_utils__WEBPACK_IMPORTED_MODULE_4__/* .omitNonReactProps */ .ly)(otherProps)), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M19.3638 4.63428H5.86279V16.4908H9.54689V18.9416L11.9999 16.4908H16.4994L19.3638 13.6286V4.63428Z",
                fill: fill !== "#fff" ? "white" : "none"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.22751 3L3 6.27066V19.3517H7.49878V21.8059H9.95492L12.4086 19.3517H16.0902L21 14.4479V3H4.22751ZM5.86289 4.63429H19.3639V13.6286L16.4995 16.4908H12L9.54699 18.9416V16.4908H5.86289V4.63429ZM10.3635 12.812H12V7.90668H10.3635V12.812ZM14.8633 12.812H16.4995V7.90668H14.8633V12.812Z",
                fill: fill
            })
        ]
    }));
};
Twitch.propTypes = {
    size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)
    ]),
    fill: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
Twitch.defaultProps = {
    size: 24,
    fill: _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].colors.icon */ .Z.colors.icon
};
/* harmony default export */ __webpack_exports__["Z"] = (Twitch);


/***/ }),

/***/ 58455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19036);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7707);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78723);








var WhatsApp = function WhatsApp(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "fill",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, (0,_services_utils__WEBPACK_IMPORTED_MODULE_4__/* .omitNonReactProps */ .ly)(otherProps)), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    fill: "none",
                    height: "24",
                    width: "24",
                    y: "0"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M19.05,4.91C17.18,3.03,14.69,2,12.04,2c-5.46,0-9.91,4.45-9.91,9.91c0,1.75,0.46,3.45,1.32,4.95L2.05,22l5.25-1.38 c1.45,0.79,3.08,1.21,4.74,1.21h0c0,0,0,0,0,0c5.46,0,9.91-4.45,9.91-9.91C21.95,9.27,20.92,6.78,19.05,4.91z M12.04,20.15 L12.04,20.15c-1.48,0-2.93-0.4-4.2-1.15l-0.3-0.18l-3.12,0.82l0.83-3.04l-0.2-0.31c-0.82-1.31-1.26-2.83-1.26-4.38 c0-4.54,3.7-8.24,8.24-8.24c2.2,0,4.27,0.86,5.82,2.42c1.56,1.56,2.41,3.63,2.41,5.83C20.28,16.46,16.58,20.15,12.04,20.15z M16.56,13.99c-0.25-0.12-1.47-0.72-1.69-0.81c-0.23-0.08-0.39-0.12-0.56,0.12c-0.17,0.25-0.64,0.81-0.78,0.97 c-0.14,0.17-0.29,0.19-0.54,0.06c-0.25-0.12-1.05-0.39-1.99-1.23c-0.74-0.66-1.23-1.47-1.38-1.72c-0.14-0.25-0.02-0.38,0.11-0.51 c0.11-0.11,0.25-0.29,0.37-0.43c0.12-0.14,0.17-0.25,0.25-0.41c0.08-0.17,0.04-0.31-0.02-0.43c-0.06-0.12-0.56-1.34-0.76-1.84 c-0.2-0.48-0.41-0.42-0.56-0.43C8.86,7.33,8.7,7.33,8.53,7.33c-0.17,0-0.43,0.06-0.66,0.31C7.65,7.89,7.01,8.49,7.01,9.71 c0,1.22,0.89,2.4,1.01,2.56c0.12,0.17,1.75,2.67,4.23,3.74c0.59,0.26,1.05,0.41,1.41,0.52c0.59,0.19,1.13,0.16,1.56,0.1 c0.48-0.07,1.47-0.6,1.67-1.18c0.21-0.58,0.21-1.07,0.14-1.18S16.81,14.11,16.56,13.99z"
                        })
                    })
                })
            })
        ]
    }));
};
WhatsApp.propTypes = {
    size: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_2___default().number)
    ]),
    fill: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
WhatsApp.defaultProps = {
    size: 24,
    fill: _styles_theme__WEBPACK_IMPORTED_MODULE_3__/* ["default"].colors.icon */ .Z.colors.icon
};
/* harmony default export */ __webpack_exports__["Z"] = (WhatsApp);


/***/ }),

/***/ 71250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7707);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78723);







var X = function X(_param) /*#__PURE__*/ {
    var _fill = _param.fill, fill = _fill === void 0 ? _styles_theme__WEBPACK_IMPORTED_MODULE_2__/* ["default"].colors.icon */ .Z.colors.icon : _fill, _size = _param.size, size = _size === void 0 ? "24" : _size, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "fill",
        "size"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, (0,_services_utils__WEBPACK_IMPORTED_MODULE_3__/* .omitNonReactProps */ .ly)(otherProps)), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M 13.712 10.622 L 20.414 3 L 18.826 3 L 13.007 9.618 L 8.36 3 L 3 3 L 10.028 13.007 L 3 21 L 4.588 21 L 10.733 14.012 L 15.64 21 L 21 21 L 13.712 10.622 Z M 11.537 13.096 L 10.826 12.099 L 5.16 4.17 L 7.599 4.17 L 12.171 10.569 L 12.884 11.566 L 18.827 19.883 L 16.388 19.883 L 11.537 13.096 Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (X);


/***/ }),

/***/ 93177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B7": function() { return /* reexport safe */ _components_CustomIcons_OnAirBasic__WEBPACK_IMPORTED_MODULE_8__.Z; },
/* harmony export */   "Od": function() { return /* reexport safe */ _components_CustomIcons_RtmpServer__WEBPACK_IMPORTED_MODULE_7__.Z; },
/* harmony export */   "YA": function() { return /* reexport safe */ _components_CustomIcons_Twitch__WEBPACK_IMPORTED_MODULE_5__.Z; },
/* harmony export */   "_F": function() { return /* reexport safe */ _components_CustomIcons_YouTube__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "_H": function() { return /* reexport safe */ _components_CustomIcons_X__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "gV": function() { return /* reexport safe */ _components_CustomIcons_Hopin__WEBPACK_IMPORTED_MODULE_6__.Z; },
/* harmony export */   "s1": function() { return /* reexport safe */ _components_CustomIcons_Facebook__WEBPACK_IMPORTED_MODULE_0__.Z; },
/* harmony export */   "tL": function() { return /* reexport safe */ _components_CustomIcons_Twitter__WEBPACK_IMPORTED_MODULE_1__.Z; },
/* harmony export */   "w2": function() { return /* reexport safe */ _components_CustomIcons_WhatsApp__WEBPACK_IMPORTED_MODULE_9__.Z; },
/* harmony export */   "yh": function() { return /* reexport safe */ _components_CustomIcons_LinkedIn__WEBPACK_IMPORTED_MODULE_4__.Z; }
/* harmony export */ });
/* harmony import */ var _components_CustomIcons_Facebook__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89887);
/* harmony import */ var _components_CustomIcons_Twitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14913);
/* harmony import */ var _components_CustomIcons_YouTube__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75523);
/* harmony import */ var _components_CustomIcons_X__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71250);
/* harmony import */ var _components_CustomIcons_LinkedIn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85978);
/* harmony import */ var _components_CustomIcons_Twitch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76381);
/* harmony import */ var _components_CustomIcons_Hopin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10299);
/* harmony import */ var _components_CustomIcons_RtmpServer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58966);
/* harmony import */ var _components_CustomIcons_OnAirBasic__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10580);
/* harmony import */ var _components_CustomIcons_WhatsApp__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58455);













/***/ }),

/***/ 86186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.Ky; },
/* harmony export */   "Pp": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "Pq": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.Dy; },
/* harmony export */   "Yh": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.NM; },
/* harmony export */   "en": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.r8; },
/* harmony export */   "jx": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.y$; },
/* harmony export */   "q1": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.pm; },
/* harmony export */   "xR": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.wx; },
/* harmony export */   "yW": function() { return /* reexport safe */ _components_Marketing__WEBPACK_IMPORTED_MODULE_0__.Al; }
/* harmony export */ });
/* harmony import */ var _components_Marketing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79593);



/***/ }),

/***/ 97702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GT": function() { return /* reexport safe */ _components_MaterialIcons_Email__WEBPACK_IMPORTED_MODULE_1__.Z; },
/* harmony export */   "Jr": function() { return /* reexport safe */ _components_MaterialIcons_PlayArrow__WEBPACK_IMPORTED_MODULE_3__.Z; },
/* harmony export */   "mB": function() { return /* reexport safe */ _components_MaterialIcons_Share__WEBPACK_IMPORTED_MODULE_4__.Z; },
/* harmony export */   "v2": function() { return /* reexport safe */ _components_MaterialIcons_Menu__WEBPACK_IMPORTED_MODULE_2__.Z; },
/* harmony export */   "x8": function() { return /* reexport safe */ _components_MaterialIcons_Close__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _components_MaterialIcons_Close__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13464);
/* harmony import */ var _components_MaterialIcons_Email__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8407);
/* harmony import */ var _components_MaterialIcons_Menu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51182);
/* harmony import */ var _components_MaterialIcons_PlayArrow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72928);
/* harmony import */ var _components_MaterialIcons_Share__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11241);








/***/ }),

/***/ 42778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Anchor; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/services/analytics.js
var analytics = __webpack_require__(627);
// EXTERNAL MODULE: ./src/services/tracking/index.ts + 1 modules
var tracking = __webpack_require__(26872);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(43119);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.1.1_7i5myeigehqah43i5u7wbekgba/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(61258);
;// CONCATENATED MODULE: ./src/components/Anchor/Anchor.styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: ",
        ";\n	text-decoration: none;\n\n	&:hover,\n	&:focus {\n		filter: brightness(1.1);\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var StyledAnchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-4b0f5fd9-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.primary.main;
});

;// CONCATENATED MODULE: ./src/components/Anchor/Anchor.tsx








var createValidHref = function(href) {
    try {
        return new URL(href).href;
    } catch (e) {
        return href.startsWith("/") ? href : "https://".concat(href);
    }
};
var Anchor = function(_param) {
    var href = _param.href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "href"
    ]);
    var trackAnchorClick = (0,react.useCallback)(function() {
        analytics/* default.track */.Z.track(tracking/* events.MAIN_CONTENT_INTERACTION_CLICKED */.U.MAIN_CONTENT_INTERACTION_CLICKED, {
            contentType: "link",
            destinationUrl: href
        });
    }, [
        href
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnchor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        href: createValidHref(href),
        onClick: trackAnchorClick
    }));
};
/* harmony default export */ var Anchor_Anchor = (Anchor);

;// CONCATENATED MODULE: ./src/components/Anchor/index.ts

/* harmony default export */ var components_Anchor = (Anchor_Anchor);


/***/ }),

/***/ 76092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _segments_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_gy3t2662bfefxvvyatkvfs3nqm/node_modules/next/head.js
var head = __webpack_require__(87859);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_gy3t2662bfefxvvyatkvfs3nqm/node_modules/next/script.js
var script = __webpack_require__(47004);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/services/analytics.js
var analytics = __webpack_require__(627);
// EXTERNAL MODULE: ./node_modules/.pnpm/next-i18next@11.3.0_22i2vm6kkdnjds7qamf3bqxxhi/node_modules/next-i18next/dist/esm/index.js + 21 modules
var esm = __webpack_require__(25941);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/Footer.js + 13 modules
var Footer = __webpack_require__(27941);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/ssrWrapper.js
var ssrWrapper = __webpack_require__(43905);
// EXTERNAL MODULE: ./workspaces/packages/component-library/src/index.ts + 28 modules
var src = __webpack_require__(80381);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-modal@3.9.1_biqbaboplfbrettd7655fr4n2y/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(61387);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.1.1_7i5myeigehqah43i5u7wbekgba/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(61258);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/IconButton/index.tsx
var IconButton = __webpack_require__(3837);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/IconButton.js

/* harmony default export */ var components_IconButton = (IconButton/* default */.Z);

// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/MaterialIcons.js
var MaterialIcons = __webpack_require__(97702);
// EXTERNAL MODULE: ./src/components/SsrLink/index.ts + 1 modules
var SsrLink = __webpack_require__(34400);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(57389);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9970);
;// CONCATENATED MODULE: ./src/services/blog/categories.ts



// If a value is undefined it will show 'All' as active in the header
var categoryToMainCategory = {
    Audio: "Audio",
    Branding: "Tutorials",
    Business: "Tutorials",
    Equipment: "Tips",
    Faith: "How to Live Stream",
    Guides: "Tips",
    "How to Live Stream": "How to Live Stream",
    Production: "How to Live Stream",
    Setup: "How to Live Stream",
    Strategy: "Strategy",
    Tips: "Tips",
    Tutorials: "Tutorials"
};
var categoryTypeToUrlMap = {
    Audio: "live-streaming-audio",
    Branding: "live-stream-branding",
    Business: "live-stream-business",
    Equipment: "live-streaming-equipment",
    Faith: "faith-based-live-streaming",
    Guides: "live-streaming-guides",
    "How to Live Stream": "how-to-live-stream",
    Production: "live-stream-production",
    Setup: "live-streaming-setup",
    Strategy: "live-streaming-strategy",
    Tips: "live-streaming-tips",
    Tutorials: "live-streaming-tutorials"
};
var getBlogCategory = function(categoryUrl) {
    return Object.keys(categoryTypeToUrlMap).find(function(key) {
        return categoryTypeToUrlMap[key] === categoryUrl;
    });
};
var getCategoryUrl = function(category) {
    return categoryTypeToUrlMap[category];
};
var getBlogMainCategory = function(category) {
    return categoryToMainCategory[category];
};
var getAllBlogCategoriesForMainCategory = function(mc) {
    var categories = Object.entries(categoryToMainCategory).reduce(function(acc, current) {
        var _current = _sliced_to_array(current, 2), category = _current[0], mainCategory = _current[1];
        if (mc === mainCategory) {
            acc.push(category);
        }
        return acc;
    }, []);
    return categories;
};
var _obj;
var categoriesWithTranslations = (_obj = {}, (0,_define_property/* default */.Z)(_obj, categoryTypeToUrlMap["How to Live Stream"], {
    slug: categoryTypeToUrlMap["How to Live Stream"],
    name: "How to Live Stream",
    translationKey: "blog.category.howToLiveStream"
}), (0,_define_property/* default */.Z)(_obj, categoryTypeToUrlMap.Strategy, {
    slug: categoryTypeToUrlMap.Strategy,
    name: "Strategy",
    translationKey: "blog.category.strategy"
}), (0,_define_property/* default */.Z)(_obj, categoryTypeToUrlMap.Audio, {
    slug: categoryTypeToUrlMap.Audio,
    name: "Audio",
    translationKey: "blog.category.audio"
}), (0,_define_property/* default */.Z)(_obj, categoryTypeToUrlMap.Tutorials, {
    slug: categoryTypeToUrlMap.Tutorials,
    name: "Tutorials",
    translationKey: "blog.category.tutorials"
}), (0,_define_property/* default */.Z)(_obj, categoryTypeToUrlMap.Tips, {
    slug: categoryTypeToUrlMap.Tips,
    name: "Tips",
    translationKey: "blog.category.tips"
}), _obj);
var allCategoryLinks = [
    {
        slug: "",
        name: "All",
        translationKey: "blog.category.all"
    }, 
].concat((0,_to_consumable_array/* default */.Z)(Object.values(categoriesWithTranslations)));

// EXTERNAL MODULE: ./src/services/tracking/index.ts + 1 modules
var tracking = __webpack_require__(26872);
// EXTERNAL MODULE: ./src/utils/hooks/index.ts + 3 modules
var hooks = __webpack_require__(19553);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(43119);
// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(5226);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/Button.js

/* harmony default export */ var components_Button = (Button/* default */.Z);

// EXTERNAL MODULE: ./workspaces/app/static/main/src/components/Logo/index.js
var Logo = __webpack_require__(18426);
;// CONCATENATED MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/Logo.js

/* harmony default export */ var components_Logo = (Logo/* default */.Z);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/components/BlogHeader/BlogHeader.styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		height: 64px;\n		width: 100%;\n		border-bottom-width: 1px;\n		border-bottom-style: solid;\n	"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 88px;\n	max-width: 1352px;\n	margin: 0 auto;\n	position: relative;\n	border-bottom-color: ",
        ";\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	align-items: center;\n	background-color: ",
        ";\n	height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		height: 64px;\n		width: 100%;\n	"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 1;\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	padding: 0 24px;\n	margin-left: auto;\n	margin-right: auto;\n	max-width: 1352px;\n	height: 88px;\n	",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		display: none;\n	"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 1;\n	display: flex;\n	flex-direction: row;\n	justify-content: center;\n	gap: 32px;\n	list-style-type: none;\n	margin: 0;\n\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.6rem;\n	font-weight: ",
        ";\n	line-height: 2.4rem;\n	cursor: pointer;\n	color: ",
        ";\n	text-decoration: none;\n	position: relative;\n\n	&:hover::after,\n	&:focus::after {\n		content: '';\n		position: absolute;\n		left: 0;\n		right: auto;\n		width: 100%;\n		top: 100%;\n		height: 2px;\n		background-color: ",
        ";\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	top: 100%;\n	right: 0;\n	padding: 0;\n	display: flex;\n	flex-direction: column;\n	gap: 24px;\n	z-index: 2;\n	list-style-type: none;\n	margin: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		display: none;\n	"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	span {\n		font-size: 1.4rem;\n		font-weight: 600;\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		display: block;\n	"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: none;\n	",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		width: 180px;\n		height: 32px;\n  "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 135px;\n	height: 24px;\n\n	",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	body {\n		overflow: ",
        ";\n	}\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}




var media = src/* mixins.media */.tA.BC;
var HeaderWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a576d04-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[200];
}, media.belowLarge(_templateObject()));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a576d04-1"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var Inner = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-8a576d04-2"
})(_templateObject4(), media.belowLarge(_templateObject3()));
var Navigation = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-8a576d04-3"
})(_templateObject6(), media.belowLarge(_templateObject5()));
var CategoryLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-8a576d04-4"
})(_templateObject7(), function(param) {
    var active = param.active;
    return active ? "bold" : "normal";
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
}, function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var VerticalNavigation = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-8a576d04-5"
})(_templateObject8());
var TryStreamYard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a576d04-6"
})(_templateObject10(), media.belowLarge(_templateObject9()));
var TryStreamYardButton = (0,styled_components_browser_esm/* default */.ZP)(components_Button).withConfig({
    componentId: "sc-8a576d04-7"
})(_templateObject11());
var MenuIconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a576d04-8"
})(_templateObject13(), media.belowLarge(_templateObject12()));
var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(components_Logo).withConfig({
    componentId: "sc-8a576d04-9"
})(_templateObject15(), media.large(_templateObject14()));
var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(_templateObject16(), function(param) {
    var disableScroll = param.disableScroll;
    return disableScroll ? "hidden" : "inherit";
});

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/components/BlogHeader/BlogHeader.tsx














lib_default().setAppElement("#app");
var mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var BlogHeader = function(param) {
    var activeCategory = param.activeCategory, theme = param.theme;
    var ref = (0,esm/* useTranslation */.$G)("blog"), blogTranslations = ref.t;
    var ref1 = (0,esm/* useTranslation */.$G)("common"), commonTranslations = ref1.t;
    var getUrlWithPreviewQuery = (0,hooks/* useBlogPreviewQuery */.Ok)();
    var ref2 = (0,react.useState)(false), showMenu = ref2[0], setShowMenu = ref2[1];
    var closeMenu = (0,react.useCallback)(function() {
        return setShowMenu(false);
    }, []);
    var toggleMenu = (0,react.useCallback)(function() {
        return setShowMenu(function(show) {
            return !show;
        });
    }, []);
    var isLargeScreen = (0,hooks/* useMediaQuery */.ac)(mediaQueries.large);
    var trackTryStreamYardClick = (0,react.useCallback)(function() {
        return analytics/* default.track */.Z.track(tracking/* events.TRY_STREAMYARD_CLICKED */.U.TRY_STREAMYARD_CLICKED);
    }, []);
    var trackCategoryClick = (0,react.useCallback)(function(param) {
        var name = param.name, location = param.location;
        return analytics/* default.track */.Z.track(tracking/* events.CATEGORY_CLICKED */.U.CATEGORY_CLICKED, {
            name: name,
            location: location
        });
    }, []);
    (0,react.useEffect)(function() {
        if (isLargeScreen) {
            closeMenu();
        }
    }, [
        closeMenu,
        isLargeScreen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {
                disableScroll: showMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
                    role: "banner",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SsrLink/* default */.Z, {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                                children: allCategoryLinks.map(function(param) {
                                    var name = param.name, slug = param.slug, translationKey = param.translationKey;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SsrLink/* default */.Z, {
                                            href: getUrlWithPreviewQuery("/blog/".concat(slug)),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink, {
                                                active: name === (activeCategory || "All"),
                                                onClick: function() {
                                                    return trackCategoryClick({
                                                        name: name,
                                                        location: "navigation"
                                                    });
                                                },
                                                children: blogTranslations(translationKey)
                                            })
                                        })
                                    }, translationKey);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TryStreamYard, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SsrLink/* default */.Z, {
                                href: "/signup",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TryStreamYardButton, {
                                    size: "medium",
                                    variant: "outlined",
                                    onClick: trackTryStreamYardClick,
                                    children: blogTranslations("blog.tryStreamYard")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIconWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconButton, {
                                "aria-haspopup": true,
                                "aria-label": commonTranslations(showMenu ? "common.menu.close" : "common.menu.open"),
                                onClick: toggleMenu,
                                children: showMenu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcons/* Close */.x8, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcons/* Menu */.v2, {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
                contentLabel: "modal",
                isOpen: showMenu,
                shouldCloseOnEsc: true,
                shouldCloseOnOverlayClick: true,
                onRequestClose: function() {
                    return setShowMenu(false);
                },
                style: {
                    content: {
                        background: theme.colors.white,
                        border: "none",
                        inset: "0 0 auto auto",
                        width: "204px",
                        padding: "24px",
                        borderRadius: 0
                    },
                    overlay: {
                        padding: 0,
                        backgroundColor: theme.colors.modalBackground,
                        zIndex: theme.zIndex.modal,
                        top: "64px"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VerticalNavigation, {
                            children: [
                                allCategoryLinks.map(function(param) {
                                    var name = param.name, slug = param.slug, translationKey = param.translationKey;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SsrLink/* default */.Z, {
                                            href: getUrlWithPreviewQuery("/blog/".concat(slug)),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryLink, {
                                                active: name === activeCategory,
                                                onClick: function() {
                                                    return trackCategoryClick({
                                                        name: name,
                                                        location: "navigation"
                                                    });
                                                },
                                                children: blogTranslations(translationKey)
                                            })
                                        })
                                    }, translationKey);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SsrLink/* default */.Z, {
                                    href: "/signup",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TryStreamYardButton, {
                                        size: "medium",
                                        variant: "outlined",
                                        onClick: trackTryStreamYardClick,
                                        children: blogTranslations("blog.tryStreamYard")
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlogHeader_BlogHeader = ((0,styled_components_browser_esm/* withTheme */.Zz)(BlogHeader));

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/components/BlogHeader/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/components/templates/BlogTemplate/BlogTemplate.styles.tsx

function BlogTemplate_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	min-height: calc(100vh - 700px);\n"
    ]);
    BlogTemplate_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogTemplate_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	background-color: ",
        ";\n"
    ]);
    BlogTemplate_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var BlogPageWrapper = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-4f5bca1e-0"
})(BlogTemplate_styles_templateObject());
var FooterWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4f5bca1e-1"
})(BlogTemplate_styles_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[100];
});

// EXTERNAL MODULE: ./src/components/CyberWeekTopBanner/index.tsx + 1 modules
var CyberWeekTopBanner = __webpack_require__(61054);
;// CONCATENATED MODULE: ./src/components/templates/BlogTemplate/BlogTemplate.tsx









var BlogTemplate = function(param) {
    var activeCategory = param.activeCategory, children = param.children, featureFlags = param.featureFlags, user = param.user;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    type: "application/rss+xml",
                    href: "https://streamyard.com/blog/rssfeed.xml"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ssrWrapper/* default */.Z, {
                i18n: esm/* i18n */.ag,
                user: user,
                withTheme: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* ThemeProvider */.f6, {
                    themeName: "marketing",
                    isGlobal: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            !(user === null || user === void 0 ? void 0 : user.email) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CyberWeekTopBanner/* default */.Z, {
                                cyberWeekBannerFeatureFlag: featureFlags["cyber-week-banner"],
                                blackFriday2023FeatureFlag: featureFlags["black-friday-2023"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogHeader_BlogHeader, {
                                activeCategory: activeCategory
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPageWrapper, {
                                children: children
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                                    i18n: esm/* i18n */.ag
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var BlogTemplate_BlogTemplate = (BlogTemplate);

;// CONCATENATED MODULE: ./src/components/templates/BlogTemplate/index.ts
// eslint-disable-next-line no-restricted-exports


// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(2272);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_gy3t2662bfefxvvyatkvfs3nqm/node_modules/next/image.js
var next_image = __webpack_require__(19020);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/components/ReducedBlogPost/ReducedBlogPost.styles.ts

function ReducedBlogPost_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	border-radius: 12px;\n	display: flex;\n	flex-direction: column;\n	box-shadow: ",
        ";\n	overflow: hidden;\n	cursor: pointer;\n	text-decoration: none;\n\n	&:focus {\n		box-shadow: ",
        ";\n	}\n"
    ]);
    ReducedBlogPost_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		width: 100%;\n	"
    ]);
    ReducedBlogPost_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 216px;\n	width: 100%;\n	position: relative;\n	",
        "\n"
    ]);
    ReducedBlogPost_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex: 1;\n	display: flex;\n	flex-direction: column;\n	align-items: flex-start;\n	padding: 16px;\n"
    ]);
    ReducedBlogPost_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 700;\n	font-size: 1.8rem;\n	line-height: 130%;\n	display: flex;\n	flex-direction: row;\n	justify-content: center;\n	color: ",
        ";\n	margin-bottom: 10px;\n"
    ]);
    ReducedBlogPost_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex: 1;\n	align-items: flex-end;\n"
    ]);
    ReducedBlogPost_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-weight: 400;\n	font-size: 1.4rem;\n	line-height: 150%;\n	text-decoration: none;\n	color: ",
        ";\n	margin-top: 6px;\n"
    ]);
    ReducedBlogPost_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ReducedBlogPost_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: ",
        ";\n	font-weight: 400;\n	font-size: 1.4rem;\n	line-height: 150%;\n	margin-bottom: 10px;\n"
    ]);
    ReducedBlogPost_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var ReducedBlogPost_styles_media = src/* mixins.media */.tA.BC;
var Post = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-ab7fa220-0"
})(ReducedBlogPost_styles_templateObject(), function(param) {
    var theme = param.theme;
    return theme.shadows.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.medium;
});
var PostThumbnail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab7fa220-1"
})(ReducedBlogPost_styles_templateObject2(), ReducedBlogPost_styles_media.belowMedium(ReducedBlogPost_styles_templateObject1()));
var PostData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab7fa220-2"
})(ReducedBlogPost_styles_templateObject3());
var PostTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab7fa220-3"
})(ReducedBlogPost_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.black;
});
var PostReadMoreWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ab7fa220-4"
})(ReducedBlogPost_styles_templateObject5());
var PostReadMore = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ab7fa220-5"
})(ReducedBlogPost_styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.blue.main;
});
var PostSummary = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-ab7fa220-6"
})(ReducedBlogPost_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[800];
});

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/components/ReducedBlogPost/ReducedBlogPost.tsx







var MAX_TEXT_LENGTH = 100;
var truncate = function(text) {
    if (!text || text.length < MAX_TEXT_LENGTH) {
        return text;
    }
    var words = text.substring(0, MAX_TEXT_LENGTH).split(" ");
    words.pop();
    return "".concat(words.join(" "), "...");
};
var ReducedBlogPost = function(param) {
    var imageSizes = param.imageSizes, onClick = param.onClick, post = param.post, shouldShowSummary = param.shouldShowSummary;
    var t = (0,esm/* useTranslation */.$G)("blog").t;
    var getUrlWithPreviewQuery = (0,hooks/* useBlogPreviewQuery */.Ok)();
    var coverImage = post.coverImage, summary = post.summary, title = post.title, slug = post.slug;
    var limitedSummary = (0,react.useMemo)(function() {
        return truncate(summary);
    }, [
        summary
    ]);
    var limitedTitle = (0,react.useMemo)(function() {
        return truncate(title);
    }, [
        title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SsrLink/* default */.Z, {
        href: getUrlWithPreviewQuery("/blog/".concat(slug)),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post, {
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PostThumbnail, {
                    children: (coverImage === null || coverImage === void 0 ? void 0 : coverImage.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: coverImage.url,
                        alt: coverImage.description,
                        layout: "fill",
                        objectFit: "cover",
                        sizes: imageSizes
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostData, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostTitle, {
                            children: limitedTitle
                        }),
                        shouldShowSummary && /*#__PURE__*/ (0,jsx_runtime.jsx)(PostSummary, {
                            children: limitedSummary
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PostReadMoreWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostReadMore, {
                                children: t("blog.overview.readMore")
                            })
                        })
                    ]
                })
            ]
        })
    }, slug);
};
/* harmony default export */ var ReducedBlogPost_ReducedBlogPost = (ReducedBlogPost);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/components/ReducedBlogPost/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogOverview/constants.ts

var constants_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var CONTENT_MAX_WIDTH = 969;
var CONTENT_VIEWPORT_WIDTH = 90;
var POST_GRID_GAP = 24;
var POSTS_PER_ROW_BELOW_MEDIUM = 1;
var POSTS_PER_ROW_BELOW_LARGE = 2;
var POSTS_PER_ROW_ABOVE_LARGE = 3;
var MAX_LARGE_IMAGE_WIDTH = Math.ceil((CONTENT_MAX_WIDTH - (POSTS_PER_ROW_ABOVE_LARGE - 1) * POST_GRID_GAP) / POSTS_PER_ROW_ABOVE_LARGE);
var REDUCED_BLOG_POST_IMAGE_SIZES = "".concat(constants_mediaQueries.belowMedium, " ").concat(CONTENT_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_MEDIUM, "vw, ").concat(constants_mediaQueries.belowLarge, " ").concat(CONTENT_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_LARGE, "vw, ").concat(constants_mediaQueries.belowXLarge, " ").concat(CONTENT_VIEWPORT_WIDTH / POSTS_PER_ROW_ABOVE_LARGE, "vw, ").concat(MAX_LARGE_IMAGE_WIDTH, "px");

// EXTERNAL MODULE: ./src/scenes/Blog/scenes/BlogOverview/background-figure.svg
var background_figure = __webpack_require__(13293);
var background_figure_default = /*#__PURE__*/__webpack_require__.n(background_figure);
;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogOverview/BlogOverview.styles.tsx

function BlogOverview_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		margin-top: 40px;\n	"
    ]);
    BlogOverview_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	align-items: flex-start;\n	justify-content: center;\n	width: ",
        "%;\n	max-width: ",
        "px;\n	margin: 60px auto;\n\n	",
        ";\n"
    ]);
    BlogOverview_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		grid-template-columns: repeat(",
        ", 1fr);\n	"
    ]);
    BlogOverview_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		grid-template-columns: repeat(",
        ", 1fr);\n	"
    ]);
    BlogOverview_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: grid;\n	gap: ",
        "px;\n	grid-template-columns: repeat(",
        ", 1fr);\n	width: 100%;\n	",
        "\n\n	",
        "\n"
    ]);
    BlogOverview_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	background-color: ",
        ";\n	background-image: url('",
        "');\n	background-position: center;\n"
    ]);
    BlogOverview_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	max-width: 1200px;\n	margin: 0 auto;\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	padding: 0 24px;\n"
    ]);
    BlogOverview_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	background-color: ",
        ";\n	height: 40px;\n	border-radius: 24px;\n	padding: 8px 16px;\n	color: ",
        ";\n	font-weight: 700;\n	font-size: 1.4rem;\n	line-height: 2.4rem;\n	margin-top: 60px;\n"
    ]);
    BlogOverview_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 3.2rem;\n	"
    ]);
    BlogOverview_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: ",
        ";\n	font-size: 4.8rem;\n	line-height: 4.8rem;\n	font-weight: bold;\n	margin: 24px 0;\n	text-align: center;\n	",
        "\n"
    ]);
    BlogOverview_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.6rem;\n	"
    ]);
    BlogOverview_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: ",
        ";\n	font-size: 1.8rem;\n	line-height: 2.7rem;\n	margin-bottom: 84px;\n	text-align: center;\n	",
        "\n"
    ]);
    BlogOverview_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 0;\n"
    ]);
    BlogOverview_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function BlogOverview_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding: 8px 8px 24px 8px;\n	text-align: center;\n	font-size: 1.8rem;\n	line-height: 2.7rem;\n"
    ]);
    BlogOverview_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var BlogOverview_styles_media = src/* mixins.media */.tA.BC;
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-0"
})(BlogOverview_styles_templateObject1(), CONTENT_VIEWPORT_WIDTH, CONTENT_MAX_WIDTH, BlogOverview_styles_media.belowMedium(BlogOverview_styles_templateObject()));
var PostGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-1"
})(BlogOverview_styles_templateObject4(), POST_GRID_GAP, POSTS_PER_ROW_ABOVE_LARGE, BlogOverview_styles_media.belowLarge(BlogOverview_styles_templateObject2(), POSTS_PER_ROW_BELOW_LARGE), BlogOverview_styles_media.belowMedium(BlogOverview_styles_templateObject3(), POSTS_PER_ROW_BELOW_MEDIUM));
var BackgroundWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-2"
})(BlogOverview_styles_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.blue.dark;
}, (background_figure_default()));
var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-3"
})(BlogOverview_styles_templateObject6());
var SelectedCategory = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-4"
})(BlogOverview_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.colors.blue.extraLight;
}, function(param) {
    var theme = param.theme;
    return theme.colors.blue.main;
});
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-7b0ed0b9-5"
})(BlogOverview_styles_templateObject9(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, BlogOverview_styles_media.belowMedium(BlogOverview_styles_templateObject8()));
var Subtitle = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7b0ed0b9-6"
})(BlogOverview_styles_templateObject11(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, BlogOverview_styles_media.belowMedium(BlogOverview_styles_templateObject10()));
var LoadTrigger = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-7"
})(BlogOverview_styles_templateObject12());
var NoMorePosts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7b0ed0b9-8"
})(BlogOverview_styles_templateObject13());

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogOverview/BlogOverview.tsx












var BlogOverview_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var INITIAL_LOADED_POSTS_COUNT = 15;
var ROWS_TO_LOAD_COUNT = 5;
var BlogOverview = function(param) {
    var category = param.category, _posts = param.posts, posts = _posts === void 0 ? [] : _posts;
    var ref;
    var ref1 = (0,react.useState)(Math.min((posts === null || posts === void 0 ? void 0 : posts.length) || 0, INITIAL_LOADED_POSTS_COUNT)), loaded = ref1[0], setLoaded = ref1[1];
    var ref2 = (0,react.useState)(((posts === null || posts === void 0 ? void 0 : posts.length) || 0) > INITIAL_LOADED_POSTS_COUNT), hasMorePosts = ref2[0], setHasMorePosts = ref2[1];
    var ref3 = (0,react.useState)(0), loadMoreCount = ref3[0], setLoadMoreCount = ref3[1];
    var t = (0,esm/* useTranslation */.$G)("blog").t;
    var categoryTranslationKey = (0,react.useMemo)(function() {
        var ref;
        if (!category) {
            return "blog.category.all";
        }
        var categoryUrl = getCategoryUrl(category);
        return (ref = categoriesWithTranslations[categoryUrl]) === null || ref === void 0 ? void 0 : ref.translationKey;
    }, [
        category
    ]);
    var isLarge = (0,hooks/* useMediaQuery */.ac)(BlogOverview_mediaQueries.large);
    var isMedium = (0,hooks/* useMediaQuery */.ac)(BlogOverview_mediaQueries.medium);
    var loadCount = (0,react.useMemo)(function() {
        if (isLarge) return 3 * ROWS_TO_LOAD_COUNT;
        if (isMedium) return 2 * ROWS_TO_LOAD_COUNT;
        return ROWS_TO_LOAD_COUNT;
    }, [
        isLarge,
        isMedium
    ]);
    var loadTriggerRef = (0,react.useRef)(null);
    var trackContentClick = (0,react.useCallback)(function(properties) {
        analytics/* default.track */.Z.track(tracking/* events.CONTENT_CLICKED */.U.CONTENT_CLICKED, properties);
    }, []);
    var trackLoadMore = (0,react.useCallback)(function(count) {
        analytics/* default.track */.Z.track(tracking/* events.BLOG_LOAD_MORE */.U.BLOG_LOAD_MORE, {
            count: count
        });
    }, []);
    var loadMore = (0,react.useCallback)(function() {
        if (!posts || !hasMorePosts) {
            return;
        }
        var newLoadMoreCount = loadMoreCount + 1;
        setLoadMoreCount(newLoadMoreCount);
        trackLoadMore(newLoadMoreCount);
        setLoaded(function(currentlyLoaded) {
            if (posts && posts.length <= currentlyLoaded + loadCount) {
                setHasMorePosts(false);
            }
            return currentlyLoaded + loadCount;
        });
    }, [
        loadCount,
        loadMoreCount,
        hasMorePosts,
        posts,
        setHasMorePosts,
        trackLoadMore, 
    ]);
    (0,react.useEffect)(function() {
        if (!loadTriggerRef.current) {
            return function() {};
        }
        var ref = loadTriggerRef.current;
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,src_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                loadMore();
            }
        }, {
            root: null,
            threshold: 0.1
        });
        observer.observe(ref);
        return function() {
            return observer.unobserve(ref);
        };
    }, [
        loadMore
    ]);
    (0,react.useEffect)(function() {
        analytics/* default.page */.Z.page(category || "All", "Blog", {
            contentType: "Blog",
            pageType: "Category",
            pageCategory: category || "All"
        });
    }, [
        category
    ]);
    (0,react.useEffect)(function() {
        setLoaded(Math.min((posts === null || posts === void 0 ? void 0 : posts.length) || 0, INITIAL_LOADED_POSTS_COUNT));
        setHasMorePosts(((posts === null || posts === void 0 ? void 0 : posts.length) || 0) > INITIAL_LOADED_POSTS_COUNT);
        setLoadMoreCount(0);
    }, [
        posts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundWrap, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectedCategory, {
                            children: t(categoryTranslationKey)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: t("blog.overview.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                            children: t("blog.overview.subtitle")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostGrid, {
                    children: (ref = (posts || []).slice(0, loaded)) === null || ref === void 0 ? void 0 : ref.map(function(post, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReducedBlogPost_ReducedBlogPost, {
                            imageSizes: REDUCED_BLOG_POST_IMAGE_SIZES,
                            post: post,
                            onClick: function() {
                                return trackContentClick({
                                    destinationContentName: post.title,
                                    contentType: "Blog",
                                    destinationUrl: post.urlPath,
                                    location: "main feed",
                                    position: index + 1
                                });
                            }
                        }, post.id);
                    })
                })
            }),
            !hasMorePosts && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoMorePosts, {
                children: t("blog.overview.noMorePosts")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadTrigger, {
                ref: loadTriggerRef
            })
        ]
    });
};
/* harmony default export */ var BlogOverview_BlogOverview = (BlogOverview);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogOverview/index.ts
// eslint-disable-next-line no-restricted-exports


// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/Marketing.js
var Marketing = __webpack_require__(86186);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(77637);
// EXTERNAL MODULE: ./src/components/Anchor/index.ts + 2 modules
var Anchor = __webpack_require__(42778);
;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Content/Content.styles.ts

function Content_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		margin-bottom: 40px;\n	"
    ]);
    Content_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Content_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	margin-bottom: 100px;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Content_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 3.2rem;\n		line-height: 1.1875;\n		margin: 32px 0 16px;\n	"
    ]);
    Content_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Content_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 4.8rem;\n	font-weight: 700;\n	line-height: 1;\n	margin: 40px 0 8px;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Content_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 2.4rem;\n		line-height: 1.25;\n		margin: 24px 0 8px;\n	"
    ]);
    Content_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Content_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 3.2rem;\n	font-weight: 700;\n	line-height: 1.1875;\n	margin: 32px 0 8px;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Content_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 2.0rem;\n	"
    ]);
    Content_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function Content_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 2.4rem;\n	font-weight: 700;\n	line-height: 1.25;\n	margin: 24px 0 0;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function Content_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.8rem;\n	"
    ]);
    Content_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function Content_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 2rem;\n	font-weight: 700;\n	line-height: 1.25;\n	margin: 20px 0 0;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function Content_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.6rem;\n	"
    ]);
    Content_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function Content_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.8rem;\n	font-weight: 700;\n	line-height: 1.25;\n	margin: 20px 0 0;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function Content_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 1.6rem;\n	"
    ]);
    Content_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function Content_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.8rem;\n	font-weight: 600;\n	line-height: 1.25;\n	margin: 16px 0 0;\n\n	",
        "\n"
    ]);
    Content_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function Content_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	background-color: ",
        ";\n	border: 0;\n	height: 1px;\n	margin: 8px 0;\n	width: 100%;\n"
    ]);
    Content_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function Content_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 16px auto 8px;\n	max-width: 100%;\n"
    ]);
    Content_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function Content_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	justify-content: center;\n	margin: auto;\n	max-width: 460px;\n	width: 100%;\n"
    ]);
    Content_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n	margin: auto;\n	max-width: 100%;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	& > iframe {\n		margin: 16px auto 8px !important;\n	}\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.6rem;\n	font-weight: 400;\n	line-height: 1.5;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 16px 0 8px;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.6rem;\n	font-weight: 400;\n	line-height: 1.5;\n	margin: 16px 0 8px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	white-space: pre-wrap;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 16px 0 8px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}


var Content_styles_media = src/* mixins.media */.tA.BC;
var ContentWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-7d4b731c-0"
})(Content_styles_templateObject1(), Content_styles_media.belowLarge(Content_styles_templateObject()));
var StyledHeading1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-7d4b731c-1"
})(Content_styles_templateObject3(), Content_styles_media.belowLarge(Content_styles_templateObject2()));
var StyledHeading2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-7d4b731c-2"
})(Content_styles_templateObject5(), Content_styles_media.belowLarge(Content_styles_templateObject4()));
var StyledHeading3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-7d4b731c-3"
})(Content_styles_templateObject7(), Content_styles_media.belowLarge(Content_styles_templateObject6()));
var StyledHeading4 = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-7d4b731c-4"
})(Content_styles_templateObject9(), Content_styles_media.belowLarge(Content_styles_templateObject8()));
var StyledHeading5 = styled_components_browser_esm/* default.h5.withConfig */.ZP.h5.withConfig({
    componentId: "sc-7d4b731c-5"
})(Content_styles_templateObject11(), Content_styles_media.belowLarge(Content_styles_templateObject10()));
var StyledHeading6 = styled_components_browser_esm/* default.h6.withConfig */.ZP.h6.withConfig({
    componentId: "sc-7d4b731c-6"
})(Content_styles_templateObject13(), Content_styles_media.belowLarge(Content_styles_templateObject12()));
var StyledHorizontalRule = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-7d4b731c-7"
})(Content_styles_templateObject14(), function(param) {
    var theme = param.theme;
    return theme.colors.line;
});
var StyledIframe = styled_components_browser_esm/* default.iframe.attrs */.ZP.iframe.attrs({
    height: 394,
    width: 700
}).withConfig({
    componentId: "sc-7d4b731c-8"
})(Content_styles_templateObject15());
var StyledImageContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7d4b731c-9"
})(Content_styles_templateObject16());
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-7d4b731c-10"
})(_templateObject17());
var StyledInstagramContainer = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-7d4b731c-11"
})(_templateObject18());
var StyledListItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-7d4b731c-12"
})(_templateObject19());
var StyledOrderedList = styled_components_browser_esm/* default.ol.withConfig */.ZP.ol.withConfig({
    componentId: "sc-7d4b731c-13"
})(_templateObject20());
var StyledParagraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-7d4b731c-14"
})(_templateObject21());
var StyledPre = styled_components_browser_esm/* default.pre.withConfig */.ZP.pre.withConfig({
    componentId: "sc-7d4b731c-15"
})(_templateObject22());
var StyledUnorderedList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-7d4b731c-16"
})(_templateObject23());

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Content/Content.tsx










var YouTubeIframe = function(_param) {
    var src = _param.src, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src"
    ]);
    var ref = (0,react.useState)(false), clicked = ref[0], setClicked = ref[1];
    var trackVideoClick = (0,react.useCallback)(function() {
        if (clicked) {
            return;
        }
        analytics/* default.track */.Z.track(tracking/* events.MAIN_CONTENT_INTERACTION_CLICKED */.U.MAIN_CONTENT_INTERACTION_CLICKED, {
            contentType: "video",
            destinationUrl: src
        });
        setClicked(true);
    }, [
        clicked,
        src
    ]);
    if (!src || !src.startsWith("https://www.youtube.com")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIframe, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        src: src
    }, props), {
        onClick: trackVideoClick
    }));
};
var BlockQuote = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInstagramContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", (0,_object_spread/* default */.Z)({}, props))
    });
};
var Image = function(param) {
    var src = param.src;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(StyledImageContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
            alt: "",
            src: (src === null || src === void 0 ? void 0 : src.startsWith("http")) ? src : "https:".concat(src)
        })
    });
};
var components = {
    a: Anchor/* default */.Z,
    blockquote: BlockQuote,
    h1: StyledHeading1,
    h2: StyledHeading2,
    h3: StyledHeading3,
    h4: StyledHeading4,
    h5: StyledHeading5,
    h6: StyledHeading6,
    hr: StyledHorizontalRule,
    iframe: YouTubeIframe,
    img: Image,
    li: StyledListItem,
    ol: StyledOrderedList,
    p: StyledParagraph,
    pre: StyledPre,
    ul: StyledUnorderedList
};
var Content_Content = function(param) {
    var content = param.post.content;
    return content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* MarkDown */.sd, {
            components: components,
            content: content
        })
    }) : null;
};
/* harmony default export */ var components_Content_Content = (Content_Content);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Content/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Header/Header.styles.ts

function Header_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 1.4rem;\n	font-weight: 400;\n	line-height: 1;\n	margin: 12px 0 0;\n"
    ]);
    Header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	max-width: 100%;\n	width: 100%;\n"
    ]);
    Header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	padding-top: 16px;\n	width: 100%;\n"
    ]);
    Header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		font-size: 3.2rem;\n		line-height: 1.1875;\n		margin: 32px 0 16px;\n	"
    ]);
    Header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Header_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 4.8rem;\n	font-weight: 700;\n	line-height: 1;\n	margin: 40px 0 8px;\n\n	",
        "\n"
    ]);
    Header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Header_styles_media = src/* mixins.media */.tA.BC;
var Author = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-1b885af-0"
})(Header_styles_templateObject());
var Header_styles_Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-1b885af-1"
})(Header_styles_templateObject1());
var Header_styles_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b885af-2"
})(Header_styles_templateObject2());
var Header_styles_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-1b885af-3"
})(Header_styles_templateObject4(), Header_styles_media.belowLarge(Header_styles_templateObject3()));

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Header/Header.tsx





var MAX_HEADER_WIDTH = 700;
var Header_Author = function(param) {
    var author = param.author;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
        children: author
    });
};
var Header = function(param) {
    var _post = param.post, author = _post.author, coverImage = _post.coverImage, title = _post.title;
    var t = (0,esm/* useTranslation */.$G)("blog").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header_styles_StyledHeader, {
        role: "banner",
        children: [
            (coverImage === null || coverImage === void 0 ? void 0 : coverImage.dimensions) && (coverImage === null || coverImage === void 0 ? void 0 : coverImage.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: coverImage.description,
                height: coverImage.dimensions.height * (MAX_HEADER_WIDTH / coverImage.dimensions.width),
                src: coverImage.url,
                width: MAX_HEADER_WIDTH
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styles_Image, {
                alt: coverImage === null || coverImage === void 0 ? void 0 : coverImage.description,
                src: coverImage === null || coverImage === void 0 ? void 0 : coverImage.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Author, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                    i18nKey: "blog.post.author",
                    t: t,
                    components: {
                        author: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Author, {
                            author: author
                        }, "author")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_styles_Title, {
                children: title
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/Header/index.ts
// eslint-disable-next-line no-restricted-exports


// EXTERNAL MODULE: ./workspaces/app/static/main/src/ssrAdapter/components/CustomIcons.js
var CustomIcons = __webpack_require__(93177);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/EmailShareButton.js
var EmailShareButton = __webpack_require__(91960);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/FacebookShareButton.js
var FacebookShareButton = __webpack_require__(92310);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/TwitterShareButton.js
var TwitterShareButton = __webpack_require__(90605);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-share@4.4.1_react@18.2.0/node_modules/react-share/es/WhatsappShareButton.js
var WhatsappShareButton = __webpack_require__(6545);
;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/SocialShare/SocialShare.styles.ts

function SocialShare_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin: 88px 20px 108px 0;\n	display: flex;\n	flex-direction: column;\n	gap: 8px;\n	position: sticky;\n	top: 88px;\n	align-self: baseline;\n"
    ]);
    SocialShare_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: fixed;\n	bottom: 16px;\n	right: 16px;\n	display: flex;\n	flex-direction: column-reverse;\n	align-items: center;\n	gap: 16px;\n	z-index: 1;\n"
    ]);
    SocialShare_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: ",
        ";\n	overflow: hidden;\n	border-radius: 32px;\n	box-shadow: ",
        ";\n	background-color: ",
        ";\n	transition: height 0.15s ease-in;\n"
    ]);
    SocialShare_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column-reverse;\n	gap: 8px;\n	padding: 16px 8px;\n"
    ]);
    SocialShare_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 48px;\n	height: 48px;\n	border-radius: 50%;\n	background-color: ",
        ";\n\n	svg {\n		fill: ",
        ";\n	}\n\n	&:hover,\n	&:active {\n		background-color: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	svg {\n		fill: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 44px;\n	height: 44px;\n	display: inline-flex;\n	align-items: center;\n	justify-content: center;\n	background: none;\n	border-radius: 4px;\n	text-decoration: none;\n	transition: all 0.15s;\n\n	&:hover {\n		background-color: ",
        ";\n	}\n\n	svg {\n		fill: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 44px;\n	height: 44px;\n\n	&:focus {\n		box-shadow: ",
        ";\n	}\n"
    ]);
    SocialShare_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SocialShare_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	",
        "\n"
    ]);
    SocialShare_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}



var BigScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8a9d8fc-0"
})(SocialShare_styles_templateObject());
var SmallScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8a9d8fc-1"
})(SocialShare_styles_templateObject1());
var SmallScreenButtonsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8a9d8fc-2"
})(SocialShare_styles_templateObject2(), function(param) {
    var expanded = param.expanded;
    return expanded ? "232px" : "0";
}, function(param) {
    var theme = param.theme;
    return theme.shadows.subtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
var SmallScreenButtonsList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8a9d8fc-3"
})(SocialShare_styles_templateObject3());
var SmallScreenShareButton = (0,styled_components_browser_esm/* default */.ZP)(components_IconButton).withConfig({
    componentId: "sc-f8a9d8fc-4"
})(SocialShare_styles_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[900];
}, function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey[400];
});
var ShareButton = (0,styled_components_browser_esm/* default */.ZP)(components_IconButton).withConfig({
    componentId: "sc-f8a9d8fc-5"
})(SocialShare_styles_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[900];
});
var ShareButtonIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f8a9d8fc-6"
})(SocialShare_styles_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.grey[200];
}, function(param) {
    var theme = param.theme;
    return theme.colors.grey[900];
});
var shareButtonCss = (0,styled_components_browser_esm/* css */.iv)(SocialShare_styles_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.misc.focusShadow;
});
var StyledEmailShareButton = (0,styled_components_browser_esm/* default */.ZP)(EmailShareButton/* default */.Z).withConfig({
    componentId: "sc-f8a9d8fc-7"
})(SocialShare_styles_templateObject8(), shareButtonCss);
var StyledFacebookShareButton = (0,styled_components_browser_esm/* default */.ZP)(FacebookShareButton/* default */.Z).withConfig({
    componentId: "sc-f8a9d8fc-8"
})(SocialShare_styles_templateObject9(), shareButtonCss);
var StyledTwitterShareButton = (0,styled_components_browser_esm/* default */.ZP)(TwitterShareButton/* default */.Z).withConfig({
    componentId: "sc-f8a9d8fc-9"
})(SocialShare_styles_templateObject10(), shareButtonCss);
var StyledWhatsappShareButton = (0,styled_components_browser_esm/* default */.ZP)(WhatsappShareButton/* default */.Z).withConfig({
    componentId: "sc-f8a9d8fc-10"
})(SocialShare_styles_templateObject11(), shareButtonCss);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/SocialShare/SocialShare.tsx









var SocialShare_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var SocialShare = function(param) {
    var contentName = param.contentName, pageUrl = param.pageUrl;
    var ref = (0,hooks/* useEditableModal */.M7)(), isOpen = ref.isOpen, close = ref.close, toggle = ref.toggle;
    var isLargeScreen = (0,hooks/* useMediaQuery */.ac)(SocialShare_mediaQueries.large);
    var trackShareClick = (0,react.useCallback)(function(shareType) {
        analytics/* default.track */.Z.track(tracking/* events.SHARE_CLICKED */.U.SHARE_CLICKED, {
            contentName: contentName,
            shareType: shareType
        });
    }, [
        contentName
    ]);
    var shareButtons = (0,react.useMemo)(function() {
        return {
            email: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmailShareButton, {
                beforeOnClick: function() {
                    return trackShareClick("email");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcons/* Email */.GT, {
                        size: 29
                    })
                })
            }),
            facebook: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFacebookShareButton, {
                onShareWindowClose: function() {
                    return trackShareClick("facebook");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcons/* Facebook */.s1, {
                        size: 29
                    })
                })
            }),
            twitter: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTwitterShareButton, {
                onShareWindowClose: function() {
                    return trackShareClick("twitter");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcons/* Twitter */.tL, {
                        size: 29
                    })
                })
            }),
            whatsapp: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWhatsappShareButton, {
                onShareWindowClose: function() {
                    return trackShareClick("whatsapp");
                },
                url: pageUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareButtonIcon, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomIcons/* WhatsApp */.w2, {
                        size: 29
                    })
                })
            })
        };
    }, [
        pageUrl,
        trackShareClick
    ]);
    (0,react.useEffect)(function() {
        close();
    }, [
        isLargeScreen
    ]);
    return isLargeScreen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(BigScreenWrapper, {
        children: [
            shareButtons.email,
            shareButtons.facebook,
            shareButtons.twitter,
            shareButtons.whatsapp
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallScreenWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallScreenShareButton, {
                onClick: toggle,
                children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcons/* Close */.x8, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MaterialIcons/* Share */.mB, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmallScreenButtonsWrapper, {
                expanded: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SmallScreenButtonsList, {
                    children: [
                        shareButtons.whatsapp,
                        shareButtons.twitter,
                        shareButtons.facebook,
                        shareButtons.email
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var SocialShare_SocialShare = (SocialShare);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/SocialShare/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/components/index.ts




;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/constants.ts

var BlogPost_constants_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var RELATED_POSTS_GRID_GAP = 24;
var RELATED_POSTS_MAX_WIDTH = 969;
var RELATED_POSTS_VIEWPORT_WIDTH = 100;
var RELATED_POSTS_VERTICAL_PADDING = 24;
var constants_POSTS_PER_ROW_BELOW_MEDIUM = 1;
var constants_POSTS_PER_ROW_BELOW_LARGE = 2;
var constants_POSTS_PER_ROW_ABOVE_LARGE = 3;
var constants_MAX_LARGE_IMAGE_WIDTH = Math.ceil((RELATED_POSTS_MAX_WIDTH - (constants_POSTS_PER_ROW_ABOVE_LARGE - 1) * RELATED_POSTS_GRID_GAP) / constants_POSTS_PER_ROW_ABOVE_LARGE);
var constants_REDUCED_BLOG_POST_IMAGE_SIZES = "".concat(BlogPost_constants_mediaQueries.belowMedium, " ").concat(RELATED_POSTS_VIEWPORT_WIDTH / constants_POSTS_PER_ROW_BELOW_MEDIUM, "vw, ").concat(BlogPost_constants_mediaQueries.belowLarge, " ").concat(RELATED_POSTS_VIEWPORT_WIDTH / constants_POSTS_PER_ROW_BELOW_LARGE, "vw, ").concat(BlogPost_constants_mediaQueries.belowXLarge, " ").concat(RELATED_POSTS_VIEWPORT_WIDTH / constants_POSTS_PER_ROW_ABOVE_LARGE, "vw, ").concat(constants_MAX_LARGE_IMAGE_WIDTH, "px");

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/BlogPost.styles.ts

function BlogPost_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		justify-content: center;\n	"
    ]);
    BlogPost_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	justify-content: space-between;\n	margin: auto;\n	max-width: 888px;\n	padding: 0 20px;\n\n	",
        "\n"
    ]);
    BlogPost_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	max-width: 700px;\n"
    ]);
    BlogPost_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	align-items: center;\n	border-top: ",
        ";\n	display: flex;\n	flex-direction: column;\n	margin: auto;\n	max-width: ",
        "px;\n	padding: 40px 0 96px;\n"
    ]);
    BlogPost_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: 3.2rem;\n	font-weight: 700;\n	line-height: 1.1875;\n	margin-bottom: 64px;\n	text-align: center;\n"
    ]);
    BlogPost_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n		padding: 0 ",
        "px;\n	"
    ]);
    BlogPost_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			max-width: calc(",
        "% - 12px);\n		"
    ]);
    BlogPost_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			max-width: ",
        "%;\n		"
    ]);
    BlogPost_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function BlogPost_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-wrap: wrap;\n	gap: ",
        "px;\n	justify-content: center;\n	width: ",
        "%;\n\n	",
        "\n\n	& > * {\n		max-width: calc(",
        "% - 16px);\n		width: 100%;\n\n		",
        "\n\n		",
        "\n	}\n"
    ]);
    BlogPost_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var BlogPost_styles_media = src/* mixins.media */.tA.BC;
var StyledBlogPost = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-3781d617-0"
})(BlogPost_styles_templateObject1(), BlogPost_styles_media.belowLarge(BlogPost_styles_templateObject()));
var StyledMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3781d617-1"
})(BlogPost_styles_templateObject2());
var StyledRelatedPosts = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3781d617-2"
})(BlogPost_styles_templateObject3(), function(param) {
    var theme = param.theme;
    return "2px solid ".concat(theme.colors.grey[120]);
}, RELATED_POSTS_MAX_WIDTH);
var StyledRelatedPostsTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-3781d617-3"
})(BlogPost_styles_templateObject4());
var StyledRelatedPostsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3781d617-4"
})(BlogPost_styles_templateObject8(), RELATED_POSTS_GRID_GAP, RELATED_POSTS_VIEWPORT_WIDTH, BlogPost_styles_media.belowLarge(BlogPost_styles_templateObject5(), RELATED_POSTS_VERTICAL_PADDING), 100 / constants_POSTS_PER_ROW_ABOVE_LARGE, BlogPost_styles_media.belowLarge(BlogPost_styles_templateObject6(), 100 / constants_POSTS_PER_ROW_BELOW_LARGE), BlogPost_styles_media.belowMedium(BlogPost_styles_templateObject7(), 100 / constants_POSTS_PER_ROW_BELOW_MEDIUM));

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/BlogPost.tsx












var BlogPost_mediaQueries = src/* mixins.mediaQueries */.tA.w5;
var BlogPost = function(param) {
    var pageUrl = param.pageUrl, post = param.post, relatedPosts = param.relatedPosts;
    var t = (0,esm/* useTranslation */.$G)("blog").t;
    var isLargeScreen = (0,hooks/* useMediaQuery */.ac)(BlogPost_mediaQueries.large);
    var trackContentClick = (0,react.useCallback)(function(properties) {
        analytics/* default.track */.Z.track(tracking/* events.CONTENT_CLICKED */.U.CONTENT_CLICKED, properties);
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        analytics/* default.page */.Z.page("Content", "Blog", {
            contentType: "Blog",
            estimatedPostLength: (ref = post.content) === null || ref === void 0 ? void 0 : ref.length,
            pageType: "Content",
            pageCategory: post.category
        });
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBlogPost, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare_SocialShare, {
                        contentName: post.title,
                        pageUrl: pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMain, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {
                                post: post
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Content_Content, {
                                post: post
                            })
                        ]
                    })
                ]
            }),
            relatedPosts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRelatedPosts, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRelatedPostsTitle, {
                        children: t("blog.post.relatedPosts")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRelatedPostsContainer, {
                        children: relatedPosts.map(function(relatedPost, k) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReducedBlogPost_ReducedBlogPost, {
                                onClick: function() {
                                    return trackContentClick({
                                        destinationContentName: relatedPost.title,
                                        contentType: "Blog",
                                        destinationUrl: relatedPost.urlPath,
                                        location: "related post panel",
                                        position: k + 1
                                    });
                                },
                                post: relatedPost,
                                shouldShowSummary: isLargeScreen,
                                imageSizes: constants_REDUCED_BLOG_POST_IMAGE_SIZES
                            }, relatedPost.id);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* MarketingCTARow */.$2, {
                cta: /*#__PURE__*/ (0,jsx_runtime.jsx)(Marketing/* MarketingSignup */.yW, {}),
                title: t("blog.cta.title")
            })
        ]
    });
};
/* harmony default export */ var BlogPost_BlogPost = (BlogPost);

;// CONCATENATED MODULE: ./src/scenes/Blog/scenes/BlogPost/index.ts
// eslint-disable-next-line no-restricted-exports


;// CONCATENATED MODULE: ./src/scenes/Blog/index.ts



;// CONCATENATED MODULE: ./src/pages/blog/[[...segments]].tsx







// category end
var PostOrPostsGroup = function(param) {
    var activeCategory = param.activeCategory, featureFlags = param.featureFlags, pageUrl = param.pageUrl, post = param.post, relatedPosts = param.relatedPosts, user = param.user, //
    category = param.category, posts = param.posts;
    var ref;
    (0,analytics/* useLoadAnalytics */.O)();
    if (posts) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogTemplate_BlogTemplate, {
            activeCategory: category,
            featureFlags: featureFlags,
            user: user,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogOverview_BlogOverview, {
                posts: posts,
                category: category
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: pageUrl
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "max-image-preview:large"
                    })
                ]
            }),
            ((ref = post.content) === null || ref === void 0 ? void 0 : ref.includes("https://www.instagram.com")) && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "instagram",
                src: "https://www.instagram.com/embed.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogTemplate_BlogTemplate, {
                activeCategory: activeCategory,
                featureFlags: featureFlags,
                user: user,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogPost_BlogPost, {
                    post: post,
                    relatedPosts: relatedPosts,
                    pageUrl: pageUrl
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _segments_ = (PostOrPostsGroup);


/***/ }),

/***/ 26872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ tracking_events; }
});

;// CONCATENATED MODULE: ./src/services/tracking/events.ts
var events = {
    CATEGORY_CLICKED: "Category Clicked",
    TRY_STREAMYARD_CLICKED: "Try StreamYard Clicked",
    SHARE_CLICKED: "Share Clicked",
    CONTENT_CLICKED: "Content Clicked",
    MAIN_CONTENT_INTERACTION_CLICKED: "Main Content Interaction Clicked",
    BLOG_LOAD_MORE: "Blog Load More",
    CASE_STUDIES_LOAD_MORE: "Case Studies Load More"
};
/* harmony default export */ var tracking_events = (events);

;// CONCATENATED MODULE: ./src/services/tracking/index.ts



/***/ }),

/***/ 19553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ok": function() { return /* reexport */ hooks_useBlogPreviewQuery; },
  "M7": function() { return /* reexport */ hooks_useEditableModal; },
  "ac": function() { return /* reexport */ hooks_useMediaQuery; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_gy3t2662bfefxvvyatkvfs3nqm/node_modules/next/router.js
var next_router = __webpack_require__(43771);
;// CONCATENATED MODULE: ./src/utils/hooks/useBlogPreviewQuery.ts

var useBlogPreviewQuery = function() {
    var router = (0,next_router.useRouter)();
    var preview = router.query.preview;
    return function(pathname) {
        return "".concat(pathname).concat(preview ? "?preview=true" : "");
    };
};
/* harmony default export */ var hooks_useBlogPreviewQuery = (useBlogPreviewQuery);

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
;// CONCATENATED MODULE: ./src/utils/hooks/useEditableModal.ts
// Simple controller for modals that have an isOpen state and an optional object that is
// being edited by the modal.

var useEditableModal = function() {
    var initialIsOpen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, initialState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref = (0,react.useState)({
        isOpen: initialIsOpen,
        state: initialState
    }), ref1 = ref[0], isOpen = ref1.isOpen, state = ref1.state, set = ref[1];
    var open = (0,react.useCallback)(function() {
        return set({
            isOpen: true,
            state: null
        });
    }, []);
    var openWithState = (0,react.useCallback)(function(newState) {
        return set({
            isOpen: true,
            state: newState
        });
    }, []);
    var close = (0,react.useCallback)(function() {
        return set({
            isOpen: false,
            state: null
        });
    }, []);
    var toggle = (0,react.useCallback)(function() {
        return set({
            isOpen: !isOpen,
            state: null
        });
    }, [
        isOpen
    ]);
    return {
        isOpen: isOpen,
        state: state,
        open: open,
        openWithState: openWithState,
        close: close,
        toggle: toggle
    };
};
/* harmony default export */ var hooks_useEditableModal = (useEditableModal);

;// CONCATENATED MODULE: ./src/utils/hooks/useMediaQuery.ts

// Returns whether or not the current media query is true.
// Based on https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/useMediaQuery/useMediaQuery.js
var useMediaQuery = function(query) {
    var ref = (0,react.useState)(false), match = ref[0], setMatch = ref[1];
    (0,react.useEffect)(function() {
        var active = true;
        var queryList = window.matchMedia(query);
        var updateMatch = function() {
            if (active) {
                setMatch(queryList.matches);
            }
        };
        updateMatch();
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query
    ]);
    return match;
};
/* harmony default export */ var hooks_useMediaQuery = (useMediaQuery);

;// CONCATENATED MODULE: ./src/utils/hooks/index.ts





/***/ }),

/***/ 13293:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDczIiBoZWlnaHQ9IjUzMiIgZmlsbD0ibm9uZSI+PHBhdGggc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIGQ9Ik0xIDE2Ni44ODhDMzYxIDM3MS4xNzYgOTQ3LjU5OC04MS44MjkgMTIwNCAxNC42NzZjMjU2LjQgOTYuNTA2LTQ5NC42NDMgMzgyLjU4My0zMjkuNDA2IDQ5MC4xMThDMTAzOS44MyA2MTIuMzI5IDE3MTIuNSAzMzkuMTc2IDE2NTUgMjQ3LjE3NmMtNDEuODQtNjYuOTM5LTIzNi0yMy41LTIzNiA1NS41czQwNy40OSAzMzUuOTI0IDY1Mi41IDE3NiIgb3BhY2l0eT0iLjIiLz48L3N2Zz4="

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8078,8045,231,5839,9020,1647,2218,6987,3905,7994,903,9774,2888,179], function() { return __webpack_exec__(12276); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);